import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import cx from 'classnames';
import PageLink from '@piconetworks/pkg-page-link';
import Form from '@piconetworks/pkg-form';
import styles from './scss/Link.module.scss.js';

var _excluded = ["linkBlocks", "richMediaData", "linkBlockClassName", "handleClick", "fieldContainerProps", "onLinkClink"];
var IframelyRichMedia = /*#__PURE__*/React.memo(function (_ref) {
  var html = _ref.html;
  useEffect(function () {
    var _window, _window$iframely;
    (_window = window) === null || _window === void 0 ? void 0 : (_window$iframely = _window.iframely) === null || _window$iframely === void 0 ? void 0 : _window$iframely.load();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
});
var FieldLinks = function FieldLinks(_ref2) {
  var _ref2$linkBlocks = _ref2.linkBlocks,
    linkBlocks = _ref2$linkBlocks === void 0 ? [] : _ref2$linkBlocks,
    _ref2$richMediaData = _ref2.richMediaData,
    richMediaData = _ref2$richMediaData === void 0 ? {} : _ref2$richMediaData,
    linkBlockClassName = _ref2.linkBlockClassName,
    _ref2$handleClick = _ref2.handleClick,
    handleClick = _ref2$handleClick === void 0 ? function () {} : _ref2$handleClick,
    fieldContainerProps = _ref2.fieldContainerProps,
    _ref2$onLinkClink = _ref2.onLinkClink,
    onLinkClink = _ref2$onLinkClink === void 0 ? function () {} : _ref2$onLinkClink,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var sortByOrder = function sortByOrder(a, b) {
    return a.order - b.order;
  };
  var LinksField = [].concat(linkBlocks).sort(sortByOrder).map(function (_ref3, index) {
    var links = _ref3.links;
    return /*#__PURE__*/React.createElement("div", {
      className: cx(styles.linkBlockContainer, linkBlockClassName),
      key: index,
      onClick: function onClick() {
        return handleClick(index);
      }
    }, [].concat(links).sort(sortByOrder).map(function (_ref4, index) {
      var id = _ref4.id,
        _ref4$title = _ref4.title,
        title = _ref4$title === void 0 ? '' : _ref4$title,
        url = _ref4.url,
        _ref4$image = _ref4.image,
        image = _ref4$image === void 0 ? '' : _ref4$image,
        _ref4$description = _ref4.description,
        description = _ref4$description === void 0 ? '' : _ref4$description,
        social_type = _ref4.social_type,
        _ref4$display = _ref4.display,
        display = _ref4$display === void 0 ? true : _ref4$display,
        image_preview = _ref4.image_preview,
        is_rich = _ref4.is_rich,
        format_type = _ref4.format_type;
      var richMedia = (richMediaData === null || richMediaData === void 0 ? void 0 : richMediaData[url]) || null;
      var isTextOnly = format_type === 'text-only';
      var isRich = richMedia && is_rich;
      return display && /*#__PURE__*/React.createElement("div", {
        className: styles.linkBlockContainer_link,
        key: index,
        onClick: function onClick() {
          return onLinkClink({
            link_id: id,
            link_url: url,
            link_social_type: social_type,
            link_title: title,
            link_description: description,
            link_type: 'link_block'
          });
        }
      }, isRich ? /*#__PURE__*/React.createElement(IframelyRichMedia, {
        html: richMedia.html
      }) : /*#__PURE__*/React.createElement(PageLink, {
        subtitle: description,
        title: title || url,
        url: url,
        image: !isTextOnly && (image_preview || image)
      }));
    }));
  });
  return /*#__PURE__*/React.createElement(Form.Field, fieldContainerProps, /*#__PURE__*/React.createElement(Field, _extends({
    component: function component() {
      return LinksField;
    }
  }, rest)));
};
FieldLinks.propTypes = {
  linkBlocks: PropTypes.array,
  fieldContainerProps: PropTypes.any,
  linkBlockClassName: PropTypes.string,
  handleClick: PropTypes.func,
  trackLinkClick: PropTypes.func
};

export { FieldLinks as default };
//# sourceMappingURL=index.js.map
